import type { ITrackData } from "./analytics";

export function hasOccured(events: Array<ITrackData>, event: ITrackData) {
    if (!Array.isArray(events) || !events.length) return false;

    return events.some((x) => JSON.stringify(x) === JSON.stringify(event));
}
